@let vs = presenter.viewState();

<spa-time-input
  [errorMessage]="vs.errorMessage"
  [isRequired]="vs.required"
  [label]="vs.displayLabel"
  [ngModel]="model()"
  [readonly]="vs.readonly || vs.disabled"
  (customBlur)="onBlur()"
  (ngModelChange)="onModelChange($event)"
/>
